import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Grupo } from 'src/app/model/index.model';
import Swal from 'sweetalert2';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { GrupoService } from 'src/app/service/index.service';
import { FilGrupoComponent } from '../../filtro/fil-grupo/fil-grupo.component';

@Component({
  selector: 'app-lst-grupo',
  templateUrl: './lst-grupo.component.html',
  styleUrls: ['./lst-grupo.component.css']
})
export class LstGrupoComponent implements OnInit {

  @ViewChild(FilGrupoComponent, { static: true }) fil: FilGrupoComponent;
  entity = "Grupos"

  items: Grupo[];
  item: Grupo;

  proccess: Boolean;

  constructor(private wsdl: GrupoService, private router: Router) {
    this.item = new Grupo();
  }

  ngOnInit() {

  }

  preNew() {
    this.item = new Grupo();
  }

  select(item: Grupo) {
    this.item = item;
  }

  cancel() {
    this.item = new Grupo();
    this.fil.list();
  }

  async setResultCancel(event: boolean) {
    UturuncoUtils.showToas("Operación cancelada", "info");
  }

  setResult(event: any) {
    this.cancel();
  }

  preDelete(item: Grupo) {
    this.item = new Grupo();
    this.item = item;

    Swal.fire({
      title: 'Esta Seguro?',
      text: '¡No podrás recuperar este archivo ' + item.nombre + '!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '¡Sí, bórralo!',
      cancelButtonText: 'No, mantenlo',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.value) {
        this.delete()
      } else if (result.dismiss === Swal.DismissReason.cancel) {

        UturuncoUtils.showToas('Tu archivo esta seguro :)', "warning")

      }
    })
  }

  async delete() {
    try {
      this.proccess = true;
      const res = await this.wsdl.doDelete(this.item.id).then();
      const result = JSON.parse(JSON.stringify(res));
      if (result.code == 200) {
        UturuncoUtils.showToas(result.msg, "success");
        this.cancel();
      } else {
        UturuncoUtils.showToas(result.msg, "error");
      }
    } catch (error) {
      UturuncoUtils.showToas("Excepción: " + error.message, "error");
    }
    this.proccess = false;
  }

  doFound(event: Grupo[]) {
    this.items = event;
  }

  linkear(id?: number) {
    this.router.navigateByUrl("admin/" + this.entity.toLocaleLowerCase() + "/abm/" + id);
  }

}
